import { apiClient, handleResponse, handleError } from '../helpers';
import { api } from '../constants';
import { createRequestCacheKey, fetchWithCache } from '../helpers/requestCache';

const BLOCKED_WORDS_TTL_MS = 30 * 60 * 1000;
const blockedWordsCacheKey = () => createRequestCacheKey('chat', 'blocked-words');

export const blockedwordService = {
    fetchBlockedWords
};

function fetchBlockedWords() {
    return fetchWithCache({
        key: blockedWordsCacheKey(),
        ttlMs: BLOCKED_WORDS_TTL_MS,
        loader: () => apiClient.get(api.blockedword.fecthBlockedwords)
            .then(handleResponse)
            .then(data => data),
    })
        .catch(error => handleError(error.response));
}
